module.exports = __webpack_public_path__ + "static/media/ico-back.7fde6176.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico-back.svg
// module id = 255
// module chunks = 8